import request from "@/api";
import type { ConsignmentFormValues } from "./types";

/** 将表单日期转换为 Vue/后端 LocalDateTime 约定的边界时间。 */
export function formatConsignmentDateTime(value: string | null | undefined, endOfDay = false): string | undefined {
    if (!value || /[T ]\d{2}:\d{2}/.test(value)) return value ?? undefined;
    return `${value}T${endOfDay ? "23:59:59" : "00:00:00"}`;
}

/** 保存前统一补齐提货周期时间，避免草稿和正式提交走出不同的参数格式。 */
function normalizeConsignmentDateTimes(values: ConsignmentFormValues): ConsignmentFormValues {
    return {
        ...values,
        deliveryStartTime: formatConsignmentDateTime(values.deliveryStartTime),
        deliveryEndTime: formatConsignmentDateTime(values.deliveryEndTime, true)
    };
}

/** 复用 Vue 寄售商品新增草稿和更新草稿接口。 */
export async function saveConsignment(id: number | string | undefined, values: ConsignmentFormValues): Promise<void> {
    const payload = normalizeConsignmentDateTimes(values);
    if (id == null) {
        await request.service.post("/admin/product-consignment/create-save", payload);
    } else {
        await request.service.post(`/admin/product-consignment/update-save/${id}`, payload);
    }
}

/** 复用 Vue 寄售商品正式提交接口，新增使用 POST，编辑使用 PUT。 */
export async function submitConsignment(id: number | string | undefined, values: ConsignmentFormValues): Promise<void> {
    const payload = normalizeConsignmentDateTimes(values);
    if (id == null) {
        await request.service.post("/admin/product-consignment", payload);
    } else {
        await request.service.put(`/admin/product-consignment/${id}`, payload);
    }
}
